import { render, staticRenderFns } from "./InstitutionalSettlementStatistics.vue?vue&type=template&id=03bddf58"
import script from "./InstitutionalSettlementStatistics.vue?vue&type=script&lang=js"
export * from "./InstitutionalSettlementStatistics.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalSettlementStatistics.vue?vue&type=style&index=0&id=03bddf58&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports